export default "__VITE_ASSET__F_ZCc_L5__"